module.exports = __webpack_public_path__ + "img/logo-2.0147994a.png";